
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Article {
  id?: string; // 改为可选，因为数据库会自动生成
  title: string;
  summary: string;
  content: string;
  date: string;
  columnType: 'industry' | 'country'; // 前端使用驼峰命名
  category: string;
  link: string;
  image: string;
  status: 'draft' | 'published';
  created_at?: string;
  updated_at?: string;
}

// 数据库字段映射接口（下划线命名）
export interface ArticleDB {
  id?: string;
  title: string;
  summary: string;
  content: string;
  date: string;
  column_type: 'industry' | 'country'; // 数据库使用下划线命名
  category: string;
  link: string;
  image: string;
  status: 'draft' | 'published';
  created_at?: string;
  updated_at?: string;
}

// 转换函数：前端格式 -> 数据库格式
export const articleToDB = (article: Article): Omit<ArticleDB, 'id' | 'created_at' | 'updated_at'> => ({
  title: article.title,
  summary: article.summary,
  content: article.content,
  date: article.date,
  column_type: article.columnType, // 转换字段名
  category: article.category,
  link: article.link,
  image: article.image,
  status: article.status,
});

// 转换函数：数据库格式 -> 前端格式
export const articleFromDB = (articleDB: ArticleDB): Article => ({
  id: articleDB.id,
  title: articleDB.title,
  summary: articleDB.summary,
  content: articleDB.content,
  date: articleDB.date,
  columnType: articleDB.column_type, // 转换字段名
  category: articleDB.category,
  link: articleDB.link,
  image: articleDB.image,
  status: articleDB.status,
  created_at: articleDB.created_at,
  updated_at: articleDB.updated_at,
});
